var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNc = function SvgNc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0035AD",
    fillRule: "evenodd",
    d: "M.683 8C2.33 3.34 6.775 0 12 0c5.225 0 9.67 3.34 11.317 8H.683Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ED4135",
    fillRule: "evenodd",
    d: "M23.317 16c.443-1.251.683-2.597.683-4s-.24-2.749-.683-4H.683A11.976 11.976 0 0 0 0 12c0 1.403.24 2.749.683 4h22.634Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#009543",
    fillRule: "evenodd",
    d: "M23.317 16C21.67 20.66 17.225 24 12 24 6.775 24 2.33 20.66.683 16h22.634Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAE600",
    d: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10.644 13.194h2.712Zm0-2.008h2.712ZM12 4.026v13.67Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M10.644 13.194h2.712m-2.712-2.008h2.712M12 4.026v13.67"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.929 17.34c-.57.002-1.14.123-1.43.355-.41.328-1.462 1.396-1.683 1.634a8 8 0 0 0 3.177.67h.016a8.002 8.002 0 0 0 3.026-.614c-.177-.195-1.14-1.24-1.678-1.69-.29-.242-.859-.358-1.428-.356ZM12 16.99c.495 0 .896-.582.896-1.301 0-.72-.401-1.302-.896-1.302-.494 0-.895.583-.895 1.302 0 .719.401 1.302.896 1.302ZM12 12.877c.6 0 1.085-.308 1.085-.687 0-.38-.486-.687-1.085-.687-.6 0-1.085.308-1.085.687 0 .38.486.687 1.085.687ZM12 10.101a1.085 1.085 0 1 0 0-2.17 1.085 1.085 0 0 0 0 2.17ZM13.302 4.975s.094.156-.104.512c-.945 1.703-1.894 1.74-2.074 1.886-.198.162-.282.15-.282.15.014-.145.027-.742.037-.799.144-.795 1.346-.784 2.286-1.599.147-.127.136-.15.136-.15Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10.129 8.637s.212.61.244 1.22c.05.977.986 1.004 1.627 1.004v-.542c-.48 0-.898-.072-1.247-.787-.173-.353-.624-.895-.624-.895ZM10.102 16.503s.341-.422.74-1.41c.21-.515.703-.815 1.158-.815v-.759c-1.032 0-1.527.383-1.58.942-.106 1.149-.318 2.042-.318 2.042ZM13.871 8.637s-.212.61-.244 1.22c-.05.977-.986 1.004-1.627 1.004v-.542c.48 0 .898-.072 1.247-.787.173-.353.624-.895.624-.895ZM13.898 16.503s-.341-.422-.74-1.41c-.21-.515-.703-.815-1.158-.815v-.759c1.032 0 1.527.383 1.58.942.106 1.149.318 2.042.318 2.042Z"
  })));
};
export default SvgNc;